import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M6.58395 10L2.99435 11.7511C2.37037 12.0554 2.37037 12.9446 2.99435 13.249L9.63526 16.4885C9.86585 16.601 10.1354 16.601 10.366 16.4885L17.0069 13.249C17.6309 12.9446 17.6309 12.0554 17.0069 11.7511L13.4173 10M6.58395 10L2.99435 8.24901C2.37037 7.94463 2.37038 7.05543 2.99435 6.75106L9.63526 3.51159C9.86585 3.39911 10.1354 3.39911 10.366 3.51159L17.0069 6.75106C17.6309 7.05544 17.6309 7.94463 17.0069 8.24901L13.4173 10M6.58395 10L9.63526 11.4885C9.86585 11.601 10.1354 11.601 10.366 11.4885L13.4173 10",
      stroke: "currentColor",
      "stroke-width": "2",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }